import { ProjectListPage } from 'Features/Project/ProjectList/ProjectList.page'

// Use the current Project List Page
// This is the landing page with no navbar and is the project homepage
export const ProjectsPage = () => {
  return <ProjectListPage />
}
